<template>
  <div :class="{ tag: true, selected }">
    <span v-if="editable" @click="deleteClicked">x</span>
    {{ tag }}
    <span v-if="count">({{ count }})</span>
  </div>
</template>
<script>
export default {
  props: {
    tag: {
      type: String,
      required: true,
    },
    editable: {
      type: Boolean,
      required: false,
      default: false,
    },
    count: {
      type: Number,
      required: false,
      default: 0,
    },
    selected: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  emits: ["delete"],
  methods: {
    deleteClicked: function() {
      this.$emit("delete");
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/_css/variables";

.tag {
  display: inline-block;
  height: 20px;
  margin-right: 5px;
  background-color: $text-info;
  color: white;
  margin-top: 5px;
  line-height: 20px;
  padding: 0 5px;
  border-radius: 0.25rem;
  font-size: 0.75rem;
  font-weight: bold;

  &.selected {
    background-color: $primary;
  }

  & > span {
    cursor: pointer;
    opacity: 0.75;
  }
}
</style>
